"use client";

import AdminSidebar from "../../components/AdminSidebar";
import Link from "next/link";
import { useEffect, useState } from "react";

export default function ReservasPage() {
  const [items, setItems] = useState<any[]>([]);

  useEffect(() => {
    fetch("/api/reservas", { cache: "no-store" })
      .then(r => r.json())
      .then(setItems);
  }, []);

  return (
    <main style={{minHeight:"100vh",background:"#050b18",color:"#fff",fontFamily:"sans-serif"}}>
      <AdminSidebar />
      <section style={{marginLeft:"260px",padding:"36px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"30px"}}>
          <div>
            <h1 style={{fontSize:"30px",margin:0,color:"#f5a623"}}>Reservas</h1>
            <p style={{color:"#8ea0c4"}}>Reservas reales guardadas en el sistema.</p>
          </div>
          <Link href="/admin/reservas/nueva" style={btn}>+ Nueva Reserva</Link>
        </div>

        <div style={box}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr style={{background:"#07111f",color:"#f5a623"}}>
              <th style={th}>Cliente</th><th style={th}>Teléfono</th><th style={th}>Ruta</th><th style={th}>Fecha</th><th style={th}>Asiento</th><th style={th}>Estado</th>
            </tr></thead>
            <tbody>
              {items.length === 0 ? <tr><td style={td} colSpan={6}>No hay reservas registradas.</td></tr> :
                items.map((x:any)=><tr key={x.id} style={{borderTop:"1px solid #1a2744"}}>
                  <td style={td}>{x.cliente}</td><td style={td}>{x.telefono}</td><td style={td}>{x.ruta}</td><td style={td}>{x.fecha}</td><td style={td}>{x.asiento}</td><td style={td}>{x.status}</td>
                </tr>)
              }
            </tbody>
          </table>
        </div>
      </section>
    </main>
  );
}

const btn={background:"#f5a623",color:"#000",padding:"13px 20px",borderRadius:"10px",fontWeight:800,textDecoration:"none"};
const box={background:"#0f1d36",border:"1px solid #1a2744",borderRadius:"18px",overflow:"hidden"};
const th={padding:"16px",textAlign:"left" as const,fontSize:"13px",fontWeight:800};
const td={padding:"16px",color:"#d8e2ff",fontSize:"14px"};
